export default "__VITE_ASSET__T1snMdl2__"